import React from 'react';
import cn from 'classnames';
import { setPopup } from 'client/redux/ui';
import { selectAuth } from 'client/redux/user/selectors';
import { useAppDispatch, useAppSelector } from 'client/hooks';
import { State as AuthState } from 'client/components/common/Login/state';

import css from './GoforisraelBtn.module.scss';
import { LINK_GOISRAEL } from 'client/constants';

interface Props {
  className?: string;
}

const GoforisraelBtn = (props: Props) => {
  const { className = '' } = props;
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);
  const [isLoginClicked, setIsLoginClicked] = React.useState(false);

  React.useEffect(() => {
    if (isLoginClicked && auth.isLoggedIn) {
      window.open(LINK_GOISRAEL, '_self');
      setIsLoginClicked(false);
    }
  }, [isLoginClicked, auth.isLoggedIn]);

  const onLoginClick = (type: AuthState['authType']) => {
    setIsLoginClicked(true);
    dispatch(setPopup({ type: 'auth', data: { initialAuthType: type } }));
  };

  return !auth.isLoggedIn ? (
    <button type="button" className={cn(css.goforisraelBtn, className)} onClick={() => onLoginClick('sign-in')}>
      <span>Get</span> Tickets
    </button>
  ) : (
    <a href={LINK_GOISRAEL} className={cn(css.goforisraelBtn, className)} target="_blank" rel="noreferrer">
      <span>Get</span> Tickets
    </a>
  );
};

export default GoforisraelBtn;
